import theme from '@flatsy/core/MuiTheme/theme'
import GtmContextProvider from '@flatsy/core/Gtm'
import { Snackbar, ThemeProvider } from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Alert } from '@material-ui/lab'
import clsx from 'clsx'
import React from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import * as ROUTES from 'src/constants/Routes'
import NotFound from 'src/containers/NotFound'
import { useMobileRedux } from 'src/hooks/Mobile'
import AppAlert from './Alert'
import ApplicationRouter from './ApplicationRouter'
import { withHeader } from './Header/WithHeader'
import { useStyle } from './Styles'

const App: React.FC = () => {
  const classes = useStyle()
  useMobileRedux()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <Router basename={import.meta.env.BASE_URL}>
          <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            className={clsx(classes.alert, 'globalError__snackbar')}
          >
            <Alert severity="error" variant="filled" className="globalError__alert" />
          </Snackbar>
          <AppAlert />

          <GtmContextProvider>
            <Switch>
              <Route
                path={[ROUTES.APPLICATION, ROUTES.NEW_APPLICATION]}
                component={withHeader(ApplicationRouter)}
              />
              <Route path={ROUTES.NOT_FOUND} component={NotFound} />
              <Redirect to={{ pathname: ROUTES.NOT_FOUND }} />
            </Switch>
          </GtmContextProvider>
        </Router>
      </CssBaseline>
    </ThemeProvider>
  )
}

export default App
